import {
  EventsList,
  useEventSelectionActions,
} from "@/shared/components/events";

import { useSessionOutletContext } from "./useSessionOutletContext";

/**
 * The session page's Events tab: the events created on this session, which
 * can be selected to add to a collection or delete. Its route in
 * `SessionsRoutes` opens only in an org that has session events.
 */
export function EventsTab() {
  const { session } = useSessionOutletContext();
  const { selectionOptions, dialogs } = useEventSelectionActions(
    session.org_id,
  );
  return (
    <>
      <EventsList
        scope={{ type: "session", id: session.session_id }}
        orgId={session.org_id}
        selectionOptions={selectionOptions}
      />
      {dialogs}
    </>
  );
}
